import React from 'react';
import { GetStarted } from './style';
import { Icon } from 'antd';

const Button = props => {
  const { label, className, disabled, loading, onClick, small, medium, large } = props;
  return (
    <GetStarted disabled={disabled} small={small} medium={medium} large={large}>
      <button data-hover={label} className={className} onClick={onClick}>
        {loading && <Icon type="loading" className="loading" />}
        <div>{label}</div>
      </button>
    </GetStarted>
  );
};

export default Button;
